var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 33.75C22.6587 33.7498 25.728 32.7006 28.2258 30.767C30.7236 28.8335 32.5085 26.1251 33.3003 23.0673M19.5 33.75C16.3413 33.7498 13.272 32.7006 10.7742 30.767C8.2764 28.8335 6.49146 26.1251 5.69967 23.0673M19.5 33.75C23.4346 33.75 26.625 27.3692 26.625 19.5C26.625 11.6308 23.4346 5.25 19.5 5.25M19.5 33.75C15.5654 33.75 12.375 27.3692 12.375 19.5C12.375 11.6308 15.5654 5.25 19.5 5.25M33.3003 23.0673C33.5932 21.9273 33.75 20.7318 33.75 19.5C33.7539 17.0492 33.1228 14.6391 31.9181 12.5048M33.3003 23.0673C29.0779 25.408 24.3279 26.6326 19.5 26.625C14.4935 26.625 9.78942 25.3346 5.69967 23.0673M5.69967 23.0673C5.40002 21.9019 5.24893 20.7033 5.25001 19.5C5.25001 16.9588 5.91501 14.5711 7.08192 12.5048M19.5 5.25C22.0274 5.24895 24.5095 5.92032 26.6918 7.19523C28.8741 8.47014 30.6779 10.3027 31.9181 12.5048M19.5 5.25C16.9726 5.24895 14.4905 5.92032 12.3082 7.19523C10.1259 8.47014 8.32216 10.3027 7.08192 12.5048M31.9181 12.5048C28.4706 15.4909 24.0608 17.1316 19.5 17.125C14.7532 17.125 10.4117 15.3833 7.08192 12.5048",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/globe.a760e53580ae03ab946dc9d527a6098c.svg";
export { ForwardRef as ReactComponent };